module.exports = __webpack_public_path__ + "img/battery.07c2f568.svg";